import { toSafeString } from '@shared/utils';
import COMPOSER_RUN_TARGET_KIND from '@/lib/model/COMPOSER_RUN_TARGET_KIND.js';
import getModelCapabilitySnapshot from '@/lib/model/getModelCapabilitySnapshot.js';
import getModelContextWindowTokens from '@/lib/model/getModelContextWindowTokens.js';
import getModelReasoningLevels from '@/lib/model/getModelReasoningLevels.js';

/* The one thing a composer send runs on. The plan picked for this message (buildComposerPlanRunPicker) runs on the
   person's Claude plan, and Claude Code owns the context window. Everything else runs
   on the Pieve model the thread or the person's defaults name. `reasoning` is what the run receives: the thinking
   level when the model offers it, else nothing. */
const buildComposerRunTarget = ({ pieveModelState } = {}) => {
  const { modelId, reasoningEffort } = pieveModelState;

  return {
    kind: COMPOSER_RUN_TARGET_KIND.pieve,
    ...pieveModelState,
    provider: toSafeString(getModelCapabilitySnapshot({ modelId })?.provider || 'openai').toLowerCase() || 'openai',
    reasoning: getModelReasoningLevels(modelId).includes(reasoningEffort) ? reasoningEffort : undefined,
    contextWindowTokens: getModelContextWindowTokens(modelId) || null
  };
};

export default buildComposerRunTarget;
